<template>
  <div class="flex flex-col gap-3 w-full">
    <div class="flex flex-col-reverse lg:flex-col relative bg-[#355185] w-full min-h-[420px] border border-[#D7D7D7] shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] p-8 rounded-[5px]">
      <img
        src="@builder/assets/images/domain-optimizer-2x.png"
        class="relative lg:absolute top-0 lg:-top-[40px] right-0 lg:right-5 w-full lg:w-[465px] mt-8 lg:mt-0"
      >
      
      <div>
        <h1 class="text-3xl font-semibold text-white">
          Estage Optimizer
        </h1>

        <div class="flex flex-col mt-4 w-full lg:w-1/2">
          <ul class="list-none">
            <li class="flex gap-3">
              <svg
                width="20"
                height="23"
                viewBox="0 0 20 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="w-[24px] h-[24px]"
              >
                <g clip-path="url(#clip0_14382_75521)">
                  <path
                    d="M4.1665 12.9998C4.1665 9.77818 6.77818 7.1665 9.99984 7.1665M13.7498 9.24984L9.99976 12.9998M18.3332 12.9998C18.3332 17.6022 14.6022 21.3332 9.99984 21.3332C5.39746 21.3332 1.6665 17.6022 1.6665 12.9998C1.6665 8.39746 5.39746 4.6665 9.99984 4.6665C14.6022 4.6665 18.3332 8.39746 18.3332 12.9998ZM10.8332 12.9998C10.8332 13.4601 10.4601 13.8332 9.99984 13.8332C9.5396 13.8332 9.1665 13.4601 9.1665 12.9998C9.1665 12.5396 9.5396 12.1665 9.99984 12.1665C10.4601 12.1665 10.8332 12.5396 10.8332 12.9998Z"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_14382_75521">
                    <rect
                      width="20"
                      height="20"
                      fill="white"
                      transform="translate(0 3)"
                    />
                  </clipPath>
                </defs>
              </svg>

              <div class="text-xl font-semibold text-white">
                Up to 80% compression <br>
                <small class="text-base text-white opacity-70">
                  Reduce image size, save bandwidth and speed up your website
                </small>
              </div>
            </li>
            <li class="flex gap-3 mt-3">
              <svg
                width="24"
                height="27"
                viewBox="0 0 24 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="w-[24px] h-[24px]"
              >
                <path
                  d="M9 6.5V5M5.06066 8.06066L4 7M5.06066 16L4 17.0607M13 8.06066L14.0607 7M3.5 12H2M8.5 11.5L12.6111 24.2778L15.5 21.3889L19.1111 25L22 22.1111L18.3889 18.5L21.2778 15.6111L8.5 11.5Z"
                  stroke="white"
                  stroke-width="1.4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div class="text-xl font-semibold text-white">
                One Click Setup <br>
                <small class="text-base text-white opacity-70">
                  Optimize images, CSS & JS with one click
                </small>
              </div>
            </li>
          </ul>
        </div>

        <div
          class="bg-[#324C7D] border text-white inline-flex items-center px-[20px] py-[10px] gap-3 rounded text-base font-medium shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] mt-4"
          :style="{borderColor: '#22375F !important'}"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="w-[20px] h-[20px]"
          >
            <g clip-path="url(#clip0_14382_74179)">
              <path
                d="M6.24984 9.99984L8.74984 12.4998L13.7498 7.49984M18.3332 9.99984C18.3332 14.6022 14.6022 18.3332 9.99984 18.3332C5.39746 18.3332 1.6665 14.6022 1.6665 9.99984C1.6665 5.39746 5.39746 1.6665 9.99984 1.6665C14.6022 1.6665 18.3332 5.39746 18.3332 9.99984Z"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_14382_74179">
                <rect
                  width="20"
                  height="20"
                  fill="white"
                />
              </clipPath>
            </defs>
          </svg>

          Estage Optimizer Turned On
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-3">
      <div class="bg-white w-full border border-[#D7D7D7] shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] p-8 rounded-[5px]">
        <h3 class="text-lg text-[#676767]">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="w-[20px] h-[20px] mr-2"
          >
            <g clip-path="url(#clip0_14382_74193)">
              <path
                d="M6.24984 9.99984L8.74984 12.4998L13.7498 7.49984M18.3332 9.99984C18.3332 14.6022 14.6022 18.3332 9.99984 18.3332C5.39746 18.3332 1.6665 14.6022 1.6665 9.99984C1.6665 5.39746 5.39746 1.6665 9.99984 1.6665C14.6022 1.6665 18.3332 5.39746 18.3332 9.99984Z"
                stroke="#4F83E3"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_14382_74193">
                <rect
                  width="20"
                  height="20"
                  fill="white"
                />
              </clipPath>
            </defs>
          </svg>

          Minify CSS Files
        </h3>

        <p class="text-base text-[#6E747A] mt-[10px]">
          If enabled, CSS files will be automatically minified to reduce their file size without modifying the functionality.
        </p>
      </div>

      <div class="bg-white w-full border border-[#D7D7D7] shadow-[0_1px_3px_0_rgba(0,0,0,0.1)] p-8 rounded-[5px]">
        <h3 class="text-lg text-[#676767]">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="w-[20px] h-[20px] mr-2"
          >
            <g clip-path="url(#clip0_14382_74193)">
              <path
                d="M6.24984 9.99984L8.74984 12.4998L13.7498 7.49984M18.3332 9.99984C18.3332 14.6022 14.6022 18.3332 9.99984 18.3332C5.39746 18.3332 1.6665 14.6022 1.6665 9.99984C1.6665 5.39746 5.39746 1.6665 9.99984 1.6665C14.6022 1.6665 18.3332 5.39746 18.3332 9.99984Z"
                stroke="#4F83E3"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_14382_74193">
                <rect
                  width="20"
                  height="20"
                  fill="white"
                />
              </clipPath>
            </defs>
          </svg>

          Minify JavaScript
        </h3>

        <p class="text-base text-[#6E747A] mt-[10px]">
          If enabled, JavaScript files will be automatically minified to reduce their file size without modifying the functionality.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DomainOptimizer'
}
</script>